import {
  ILazyAutocompleteFieldProps,
  ListItemText,
  ListItem,
  Typography,
} from '@occc-app/design-system';
import { OpenCommerceUserFilter, MembershipCommentFragment } from '@occc/graphql';
import { useGetOpenCommerceUsersLazy } from '@occc-app/dataAccessLayer/openCommerceUser/queries';
import { DateTimeFormat, formatDateTime, parseDate } from '@occc-app/lib/date';

import { TableField } from '@occc/ui-design-system';
import { CommentsFilterFormAuthorValues } from './comments-filter-form.type';

export const makeQueryOpenCommerceUserFilter = (search?: string): OpenCommerceUserFilter => ({
  search,
});

export const renderUserSelectOption: ILazyAutocompleteFieldProps<
  CommentsFilterFormAuthorValues,
  ReturnType<typeof useGetOpenCommerceUsersLazy>['response']
>['renderOption'] = (props, option) => (
  <ListItem {...props} key={option.value}>
    <ListItemText primary={option.description} secondary={option.value} />
  </ListItem>
);

export const mapUsersQueryResponseToRawArray: ILazyAutocompleteFieldProps<
  CommentsFilterFormAuthorValues,
  ReturnType<typeof useGetOpenCommerceUsersLazy>['response']
>['mapQueryResponseToRawArray'] = (res) =>
  (res?.data || []).map((i) => ({
    email: i.email,
    name: [i.name.first, i.name.last].filter(Boolean).join(' ') || undefined,
  }));

export const mapUserRawResponseItemToAutocompleteOption: ILazyAutocompleteFieldProps<
  CommentsFilterFormAuthorValues,
  ReturnType<typeof useGetOpenCommerceUsersLazy>['response']
>['mapRawResponseItemToAutocompleteOption'] = (res) => ({
  value: res.email,
  label: res.email,
  description: res.name,
  _raw: res,
});

export const makeFields = (comment: MembershipCommentFragment): TableField[] => [
  {
    label: 'Date',
    value: (
      <Typography variant='body2' noWrap>
        {formatDateTime(parseDate(comment.createdAt), DateTimeFormat.DateWithYear)}
      </Typography>
    ),
  },
  {
    label: 'Notes',
    value: comment.text,
  },
  {
    label: 'Comment by',
    value: comment.author.email,
  },
];
